import React from 'react';
import SerpPreview from 'react-serp-preview';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { DialogContent, Typography, Tabs, Tab } from '@material-ui/core';
import { useStoreState } from 'easy-peasy';

import _e from 'common/localeUtil';
import { a11yProps, TabPanel } from '../tab/tab';
import { getFullSubdomainURL } from '../../utils';
import GenericDialog from './GenericDialog';
import SEOPreview from '../SEOPreview';

const useStyles = makeStyles(theme => ({
	line: {
		border: '1px solid #bababa',
		width: '100%'
	},
	dialogContent: {
		overflow: 'hidden',
		padding: 0,
		// paddingTop: 17,
		// paddingBottom: 17,

		'& .MuiGrid-item': {
			padding: 0
		}

		// background: '#f2f2f2'
	},
	inputColor: {
		marginTop: theme.spacing(1.5),
		marginLeft: theme.spacing(2)
	},
	previewSectionTitle: {
		color: 'rgb(34, 91, 171)',
		fontSize: theme.typography.body1.fontSize,
		fontWeight: 'bold',
		marginBottom: theme.spacing(1.5)
	},
	previewSectionContent: {
		background: '#f2f2f2',
		padding: theme.spacing(3)
		// marginBottom: theme.spacing(1.5)
	},
	tabs: {},
	tab: {
		'& .MuiTab-wrapper': {
			textTransform: 'capitalize',
			// color: 'black',
			fontSize: 15
			// color: '#225bab',
			//
			// fontWeight: 'bold'
		},
		'&.Mui-selected': {
			color: '#225bab',
			fontWeight: 'bold'
		}
	},
	contentWrapper: {
		background: 'white',
		padding: 19,
		'& div div': {
			marginBottom: 8
		},
		'& div': {
			width: '100%'
		}
	},
	socialPreviewWrapper: {
		padding: 19,
		background: 'white'
	},
	socialPreview: {
		width: '100%',
		border: '1px solid rgb(225, 232, 237)',
		overflow: 'hidden',
		textDecoration: 'none',
		'-webkit-tap-highlight-color': 'rgb(245, 248, 250)',
		cursor: 'pointer',
		boxShadow: 'rgba(0, 0, 0, 0.08) 0px 4px 8px 0px'
	},
	socialPreviewCover: {
		height: 125,
		width: 125
	},
	socialPreviewHeader: {
		fontSize: '16px'
	},
	socialPreviewDesc: {
		fontSize: '14px'
	},
	socialPreviewUrl: {
		fontSize: '12px',
		color: 'rgb(24, 25, 25)'
	},
	socialPreviewContent: {
		paddingLeft: theme.spacing(2)
	}
}));

const PreviewSEODialog = ({ open, handleClose, seoImageUrl }) => {
	const classes = useStyles();
	const subdomain = useStoreState(state => state.template.subdomain);
	const seo = useStoreState(state => state.template.seo);
	const { seo_title = '', seo_description = '', seo_image_url } = seo || {};
	const seoImage = seoImageUrl || seo_image_url;
	const fullWebsiteUrl = getFullSubdomainURL(subdomain);

	const [value, setValue] = React.useState(0);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const renderContent = () => {
		return (
			<>
				<div className="dialogTitle">
					<Typography variant="body1">{_e('seo_preview_desc')}</Typography>
				</div>
				<DialogContent className={classes.dialogContent}>
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="tabs"
						className={classes.tabs}
					>
						<Tab
							label={_e('search_engine')}
							{...a11yProps(0)}
							className={classes.tab}
						/>
						<Tab label={_e('social_media')} {...a11yProps(1)} className={classes.tab} />
					</Tabs>

					<TabPanel value={value} index={0}>
						<div className={classes.previewSectionContent}>
							<div className={classes.contentWrapper}>
								<SerpPreview
									title={seo_title}
									width="100%"
									metaDescription={seo_description}
									url={fullWebsiteUrl}
								/>
							</div>
						</div>
					</TabPanel>
					<TabPanel value={value} index={1}>
						<div className={classes.previewSectionContent}>
							<div className={classes.socialPreviewWrapper}>
								<SEOPreview
									header={seo_title}
									description={seo_description}
									media={seoImage}
									url={fullWebsiteUrl}
									classes={{
										root: classes.socialPreview,
										media: classes.socialPreviewCover,
										header: classes.socialPreviewHeader,
										description: classes.socialPreviewDesc,
										url: classes.socialPreviewUrl,
										content: classes.socialPreviewContent
									}}
								/>
							</div>
						</div>
					</TabPanel>
				</DialogContent>
			</>
		);
	};

	return (
		<GenericDialog
			content={renderContent()}
			title={_e('your_seo_preview')}
			open={open}
			handleClose={handleClose}
		/>
	);
};

PreviewSEODialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	seoImageUrl: PropTypes.string
	// handleBackgroundChange: PropTypes.func
};

export default PreviewSEODialog;
